import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import { MapPin, Clock } from "lucide-react";

export default function AttractionsPage() {
  const [data, setData] = useState(null);
  useEffect(() => { http.get("/public/property").then((r) => setData(r.data)); }, []);
  if (!data) return null;
  return (
    <div>
      <PublicHeader />
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16">
        <div className="eyebrow mb-3">Explore</div>
        <h1 className="h1-hero text-5xl md:text-6xl mb-4">Explore Around Freebird Nest</h1>
        <p className="mb-10 max-w-2xl" style={{ color: "var(--muted)" }}>Temples, waterfalls, mountain trails and quiet moments in nature.</p>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {data.attractions.map((a, i) => (
            <div key={a.id} className="card" data-testid={`attraction-${i}`}>
              <img src={a.image} alt={a.name} className="w-full aspect-[4/3] object-cover rounded-xl mb-4" />
              <span className="badge-terracotta mb-2 inline-block">{a.category}</span>
              <h3 className="font-serif text-2xl mb-2">{a.name}</h3>
              <p className="text-sm mb-4" style={{ color: "var(--muted)" }}>{a.description}</p>
              {(a.distance || a.travel_time) && (
                <div className="flex gap-4 text-xs" style={{ color: "var(--pine)" }}>
                  {a.distance && <span className="flex items-center gap-1"><MapPin size={13} /> {a.distance}</span>}
                  {a.travel_time && <span className="flex items-center gap-1"><Clock size={13} /> {a.travel_time}</span>}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <PublicFooter />
    </div>
  );
}
